import Analise from "./Analises";
import Metas from "./Metas";
import Uso from "./Uso";

const Home = () => {
  return (
    <div className="container mx-auto p-6">
      <Analise />
      <Metas />
      <Uso />
    </div>
  );
};

export default Home;
